<template>
  <div id="app" :class="{ 'recipe-visible': selectedRecipe }">
    <!-- <div class="search-options">
      <span>Title</span>
      <span>Ingredients</span>
    </div> -->
    <div class="search">
      <div v-show="!selectedRecipe" class="search__container">
        <div class="search__input">
          <input v-model="searchInput"
                 type="text"
                 name=""
                 value=""
                 placeholder="Search by term or type 'all'"
          ><span v-if="searchResults">{{ searchResults.length }}</span></input>
          <div v-show="searchInput" class="clear-input" @click="searchInput = ''">×</div>
        </div>
        <div v-show="searchResults" class="search__results">
          <div v-for="result in searchResults"
               :key="result.id"
               @click="selectRecipe(result)"
          >
            {{ result.title }}
          </div>
        </div>
      </div>
      <div v-show="selectedRecipe" class="back-to-search" @click="backToSearch()">Back to search</div>
    </div>
    <div class="recipe">
      <div class="recipe__container">
        <div v-if="selectedRecipe" class="recipe">
          <div class="recipe__ingredients">
            
            <h1>{{ selectedRecipe.title }}</h1>
            <ul>
              <li v-for="ingredient in selectedRecipe.ingredients">{{ ingredient }}</li>
            </ul>
          </div>
          <div class="recipe__prep">
            <p>{{ selectedRecipe.prep }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import recipes from '../../static/recipes'
  import db from '../firebaseInit'
  import _ from 'lodash'
  
  export default {
    data() {
      return {
        recipes,
        searchInput: '',
        searchResults: null,
        selectedRecipe: null
      }
    },
    methods: {
      filterRecipes() {
        if (this.searchInput === 'all') {
          this.searchResults = _.sortBy(this.recipes, ['title'])
        } else {
          if (this.searchInput) {
            this.searchResults = this.recipes.filter(obj => {
              return obj.title.toUpperCase().includes(this.searchInput.toUpperCase())
            })
          }
        }
        
      },
      selectRecipe(recipe) {
        this.selectedRecipe = recipe
        this.$router.push({ query: { recipe: recipe.id } })
        this.searchInput = ''
        this.searchResults = null
      },
      backToSearch() {
        this.selectedRecipe = null
        this.$router.push({ query: undefined })
      }
    },
    computed: {
      // filteredRecipes() {
      //   return this.recipes.filter(function(obj) { return obj.post_content.indexOf('http') == -1 })
      //   // return _.groupBy(sansLinks, 'ID')
      // }
    },
    watch: {
      searchInput: function() {
        if (this.searchInput.length > 2) {
          this.debouncedFilter()
        } else {
          this.searchResults = null
        }
      }
    },
    created() {
      // GET FROM FIRESTORE
      // db.collection('recipes').get().then(recipes => {
      //   recipes.forEach(recipe => {
      //     const data = {
      //       'id': recipe.data().ID,
      //       'content': recipe.data().post_content,
      //       'name': recipe.data().post_name,
      //       'title': recipe.data().post_title
      //     }
      //     this.recipes.push(data)
      //   })
      // })
      this.debouncedFilter = _.debounce(this.filterRecipes, 500)
    },
    mounted() {
    }
  }
</script>

<style lang="scss">
  @import '../assets/reset';
  @import url('https://fonts.googleapis.com/css?family=Work+Sans');

  html {
    box-sizing: border-box;
  }  
  *, *:before, *:after {
    box-sizing: inherit;
  }
  body {
    // background-image: url('assets/lettuce.jpg');
    // background-size: cover;
    overflow: hidden;
  }
  body, input {
    font-family: 'Work Sans', sans-serif;
    font-size: 16px;
  }
  #app {
    width: 100vw;
    height: 100vh;
    background: #a2e47c;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    // align-items: center;
    // padding-top: 60px;
    // position: relative;
    // top: 0;
    // transition: top .15s linear;
    &.recipe-visible {
      // top: -100vh;
    }
  }
  .search, .recipe {
    flex: 0 0 100vh;
  }
  .search {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    transition: flex-basis .15s linear;
    .recipe-visible & {
      flex: 0 0 60px;
    }
    // background: blue;
    &__container {
      width: 60%;
      min-width: 400px;
      max-width: 800px;
      height: auto;
      display: flex;
      flex-direction: column;
      margin: 0 0 0 0;
      border-radius: 6px;
      box-shadow: 0 5px 20px rgba(0,0,0,0.1);
      overflow: hidden;
      // .recipe-visible & {
      //   min-width: 200px;
      //   max-width: 200px;
      //   border-radius: 15px;
      // }
    }
    &__input {
      flex: 0 0 60px;
      display: flex;
      background: #fff;
      // .recipe-visible & {
      //   flex: 0 0 30px;
      // }
      input {
        flex: 1 1 auto;
        padding-left: 24px;
        border: 0;
        background: none;
        &:focus {
          outline: 0;
        }
      }
      .clear-input {
        flex: 0 0 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 24px;
        color: #ccc;
        cursor: pointer;
        // background: red;
      }
    }
    &__results {
      flex: 1 1 auto;
      background: #fff;
      padding: 0 0 10px 0;
      background: #f5f5f5;
      border-top: 1px solid #e6e6e6;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        display: none;
      }
      // .recipe-visible & {
      //   display: none;
      // }
      div {
        padding: 24px 24px;
        border-bottom: 1px solid #e6e6e6;
        &:hover {
          background: lighten(red, 20%);
          cursor: pointer;
        }
      }
    }
    .back-to-search {
      cursor: pointer;
    }
  }
  .recipe {
    flex: 1 1 auto;
    display: flex;
    justify-content: center;
    padding: 40px;
    background: #fff;
    &__container {
      width: 80%;
      min-width: 400px;
      max-width: 800px;
    }
    &__ingredients {
      flex: 0 0 200px;
    }
    &__prep {
      flex: 1 1 auto;
      line-height: 26px;
      padding-left: 30px;
    }
  }
</style>
